import React, { useState, useRef, useEffect } from 'react';
import { DefaultProfileIcon } from '../utilities/resources';
import Experts from './Experts';
import Img from './Img';
import { PlayCircleFilled, EyeFilled, ArrowRightOutlined } from '@ant-design/icons';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import ReadMore from './ReadMore';
import { Image } from 'antd';
import VideoPlayer from '../videoplayer/Player';
import { testimonialTrackerService } from '../services/apiServices';
import { getDeviceInfo, isAuthenticated } from '../utilities';
import { useDispatch } from 'react-redux';
import { INITIATE_AUTH_DRAWER } from '../actions/types';

function SingleVideoCards({ items, sectionName }) {
  const [open, setOpen] = useState(false);
  const [elapsedTime, setElapsedTime] = useState('');
  const boxRef = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (elapsedTime === '0:05') {
      postTestimonialTracker();
    }
  }, [elapsedTime]);

  const postTestimonialTracker = () => {
    const payloads = {
      testimonialId: items.id,
      deviceInfo: getDeviceInfo(),
    };
    testimonialTrackerService(payloads)
      .then((response) => console.log(''))
      .catch((error) => console.log(error));
  };

  const handleOpenModal = () => {
    if (items.contentType === 0 && !isAuthenticated()) {
      dispatch({ type: INITIATE_AUTH_DRAWER });
      return false;
    } else {
      if (items.contentType === 0) {
        setOpen(true);
        postTestimonialTracker();
      } else {
        setOpen(true);
      }
    }
  };

  return (
    <div className='singleVideoCardsWrapper'>
      <div className='singleVideoCardsHeading'>
        <p className='topLabelText'>Watch</p>
        <h1>{sectionName}</h1>
        <p>
          Here
          <ArrowRightOutlined />
        </p>
      </div>
      <div className='singleVideoCards'>
        <div className='singleVideoCardsMedia' onClick={handleOpenModal}>
          <img src={items.thumbnail} alt={items.title} />
          <button className='videoPlayButton'>{items.contentType === 1 ? <PlayCircleFilled /> : <EyeFilled />}</button>
        </div>
        <div ref={boxRef} className='singleVideoCardsContent'>
          <h2 className='videosCardsTitle'>{items.title}</h2>
          <p className='videosCardsDescription'>{items.description}</p>
          <AllExperts items={items} boxRef={boxRef} />
        </div>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} center>
        <div className='videoModalHeader videosCardsTitle' style={{ fontWeight: 700 }}>
          {sectionName}
        </div>
        {items.contentType === 1 ? (
          <div className='videoPlayerSection'>
            <VideoPlayer videoUrl={items.testimonialContent} setElapsedTime={setElapsedTime} />
          </div>
        ) : (
          <div className='imageSection'>
            <Image src={items.testimonialContent} alt={items.title} />
          </div>
        )}
        <div className='videoModalFooter'>
          <h2 className='videosCardsTitle'>{items.title}</h2>
          <AllExperts items={items} boxRef={boxRef} />
          <ReadMore className='videosCardsDescription' content={items.description} charLimit={450} />
        </div>
      </Modal>
    </div>
  );
}

export default SingleVideoCards;

const AllExperts = ({ items, boxRef }) => {
  return items.experts && items.experts.length === 1 ? (
    <div className='singleExpertGrid'>
      <div className='expertsDp'>
        <Img src={items.experts[0].profilePic} defaultSrc={DefaultProfileIcon} alt='' />
      </div>
      <div className='expertInfo'>
        <span>{items.experts[0].expertName}</span>
        <span>{items.experts[0].qualification}</span>
      </div>
    </div>
  ) : items.experts && items.experts.length > 1 ? (
    <Experts data={items.experts} containerRef={boxRef} fixedLimit={window.innerWidth < 550 ? 2 : null} />
  ) : null;
};
